import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./PinPopUp.module.css";
import Modal from "../Modal";
import StartOverIcon from "./Start_Over_Button.svg";
import PinInput from "react-otp-input";
import { useTranslation } from "react-i18next";

export function PinPopUp({ isOpen, onClose }) {
  const tempPin = "1234";
  const {t} = useTranslation();
  const [pin, setPin] = useState("");
  const [confirmPin, setConfirmPin] = useState("");
  const [error, setError] = useState(false);

  const pinInputKey = error ? "step2" : "step1";

  const handlePinChange = (value) => {
    if (!error) {
      setPin(value);
      if (value.length === 4) {
        const isPinValid = validatePin(value);
        if (!isPinValid) {
          setError(true);
          setPin("");
          setConfirmPin("");
        } else {
          handleClose();
        }
      }
    } else {
      setConfirmPin(value);
      if (value.length === 4) {
        // Validate the re-entered PIN
        if (validatePin(value)) {
          setError(false);
          handleClose();
        } else {
          setConfirmPin("");
        }
      }
    }
  };

  const validatePin = (inputPin) => {
    return inputPin === tempPin;
  };

  const handleClose = () => {
    setPin("");
    setConfirmPin("");
    setError(false);
    onClose();
  };

  const getInputStyle = (index) => {
    return {
      width: "1rem",
      height: "1rem",
      margin: "0 0.5rem",
      borderRadius: "50%",
      border: "1px solid #243746",
      textAlign: "center",
      backgroundColor: pin[index] || confirmPin[index] ? "#243746" : "#ffff",
    };
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} className={styles.modal}>
      <div className={styles.container}>
        <div className={styles.content}>
          {error ? (
            <>
              <div className={styles.startContainer} onClick={handleClose}>
                <img src={StartOverIcon} alt="Start Over" />
                <p className={styles.startText}>{t("Start Over")}</p>
              </div>

              <h3 className={styles.step}>{t("Step 2")}</h3>
              <p className={styles.text}>
                {t("Re-enter Your Management Team Passcode")}
              </p>
            </>
          ) : (
            <>
              <h3 className={styles.step}>{t("Step 1")}</h3>
              <p className={styles.text}>
                {t("Enter Your Management Team Passcode")}
              </p>
            </>
          )}

          <PinInput
            key={pinInputKey}
            value={error ? confirmPin : pin}
            onChange={handlePinChange}
            numInputs={4}
            separator={""}
            isInputNum={true}
            shouldAutoFocus={true}
            inputStyle={styles.inputStyle}
            focusStyle={styles.focusStyle}
            renderInput={(props, index) => (
              <input
                {...props}
                className={`${getInputStyle(index)} ${props.className}`}
                key={index}
                style={getInputStyle(index)}
              />
            )}
          />
        </div>
      </div>
    </Modal>
  );
}

PinPopUp.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
